"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = play;
var audio = void 0;

function play(url) {
  if (!audio) {
    audio = new Audio();
  }

  audio.pause();
  audio.src = cdnnify(url);
  audio.play();
}

function cdnnify(original) {
  // Take last 16 characters without the .mp3 url and calculate a mod
  // 4 hash. This way the CDN for an url will be always the same and
  // we can reuse cache
  var cdn = Array.prototype.reduce.call(original.substr(-20, 16), function (sum, character) {
    return sum + character.charCodeAt(0);
  }, 0) % 4;
  return original.replace(/(https?:\/\/assets)(\d)(.iknow.jp\/)/, function (match, pre, number, post) {
    return pre + cdn + post;
  });
}